class DateTimes {
  static get today() { return new Date(); }

  static get yesterday() {
    const dt = new Date();
    dt.setDate(dt.getDate() - 1);
    return dt;
  }

  static get yesterdayDateString() {
    const dt = DateTimes.yesterday;

    const d = dt.getDate();
    const m = dt.getMonth() + 1;
    const y = dt.getFullYear();

    return `${ (d <= 9 ? `0${ d }` : d) }-${ (m <= 9 ? `0${ m }` : m) }-${ y }`;
  }

  static get utcDate() {
    return new Date(DateTimes.today.getUTCFullYear(), DateTimes.today.getUTCMonth(), DateTimes.today.getUTCDate());
  }
}

export default DateTimes;
